// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"812":"c553abc4","903":"93d71781"}[chunkId] + ".chunk.css";
};